import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { PlanService } from 'src/app/services/planService/plan.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-add-plan',
  templateUrl: './add-plan.component.html',
  styleUrls: ['./add-plan.component.scss']
})
export class AddPlanComponent implements OnInit {

  public form: FormGroup;
  public isEdit = false;
  public isExcedent = false;
  public modalTitle = '';

  constructor(
    public ref: MatDialogRef<AddPlanComponent>,
    private fb: FormBuilder,
    private planService: PlanService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.isExcedent = this.data?.type === 'excedent';
    this.isEdit = !!this.data?.data;

    this.modalTitle = this.isExcedent
      ? (this.isEdit ? 'Editar Excedente' : 'Nuevo Excedente')
      : (this.isEdit ? 'Editar Plan' : 'Nuevo Plan');

    // Construimos el formulario según el tipo
    this.form = this.isExcedent ? this.buildExcedentForm() : this.buildPlanForm();

    // Si estamos editando, precargamos valores
    if (this.isEdit) {
      this.populateForm();
    }
  }

  buildPlanForm(): FormGroup {
    return this.fb.group({
      title: ['', Validators.required],
      precio: ['', Validators.required],
      time: ['', Validators.required],
      minutes: ['', Validators.required],
    });
  }

  buildExcedentForm(): FormGroup {
    return this.fb.group({
      title: ['Excedente', Validators.required],
      excedentPrice: ['', Validators.required],
      excedentHoursBlock: ['', Validators.required],
      excedentMinutesBlock: ['', Validators.required],
    });
  }

  populateForm() {
    const item = this.data.data;

    if (this.isExcedent) {
      this.form.patchValue({
        title: 'Excedente',
        excedentPrice: item.precio,
        excedentHoursBlock: item.time,
        excedentMinutesBlock: item.timeCalls,
      });
    } else {
      const precio = item.precio.split(" ")[1] || item.precio;
      this.form.patchValue({
        title: item.title,
        precio,
        time: item.time,
        minutes: item.minutes,
      });
    }
  }

  async submit() {
    try {
      if (this.form.invalid) {
        return Swal.fire({
          title: "Todos los campos son obligatorios",
          icon: "error",
        });
      }

      Swal.fire({
        title: "Guardando...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading()
      });

      if (this.isExcedent) {
        await this.saveExcedent();
      } else {
        await this.savePlan();
      }

      Swal.close();
      await Swal.fire({
        icon: "success",
        title: "Datos guardados",
        showConfirmButton: false,
        timer: 1000
      });
      this.ref.close(true);

    } catch (error) {
      Swal.fire({
        title: "Ocurrió un error inesperado",
        text: "Si el problema persiste, favor de reportar el error",
        icon: "error",
      });
    }
  }

  private async savePlan() {
    const form = this.form.value;
    form.title = form.title.toUpperCase();

    if (this.isEdit) {
      await this.planService.updatePrice(this.data.data._id, form);
    } else {
      await this.planService.addPlan(form);
    }
  }

  private async saveExcedent() {
    const form = this.form.value;
    form.title = 'Excedente';

    await this.planService.updateExcedent(this.data.data._id, form);
  }

  onlyNums(event: any) {
    const input = event.target.value;
    event.target.value = input.replace(/\D/g, '');
  }
}
